var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33332 5.33333L8.24999 0.416666C8.40277 0.263889 8.59721 0.1875 8.83332 0.1875C9.06943 0.1875 9.26388 0.263889 9.41666 0.416666C9.56943 0.569444 9.64582 0.763888 9.64582 1C9.64582 1.23611 9.56943 1.43056 9.41666 1.58333L3.91666 7.08333C3.74999 7.25 3.55555 7.33333 3.33332 7.33333C3.1111 7.33333 2.91666 7.25 2.74999 7.08333L0.583323 4.91667C0.430545 4.76389 0.354156 4.56944 0.354156 4.33333C0.354156 4.09722 0.430545 3.90278 0.583323 3.75C0.736101 3.59722 0.930545 3.52083 1.16666 3.52083C1.40277 3.52083 1.59721 3.59722 1.74999 3.75L3.33332 5.33333Z",
    fill: "#9AE6B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/CheckMark.bbbd35ed1eae1e2d1000c96b148beaca.svg";
export { ForwardRef as ReactComponent };